export default theme => ({
  layerOptions: {
    padding: 10,
    backgroundColor: 'white',
    
  }
})